// extracted by mini-css-extract-plugin
export default {"shield":"shield--xESLf"};